module.exports = __webpack_public_path__ + "static/media/UserManagement_white.77767ea9.svg";